function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.998 10.846l-7.747-4.47 7.747-4.471 7.75 4.471-7.75 4.47zM11 21.5l-7.75-4.572V7.75L11 12.32v9.18zM20.75 7.75L13 12.32v9.18l7.75-4.571V7.75z",
  fill: "current"
});

function SvgRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgRoom;